export default function PHP_uasort() {
  return (
    <div>
      <h1>PHP_uasort</h1>
    </div>
  );
}
